import { useEffect, useState } from 'react';
import { useSessionStore } from '@/state/session-store';

interface Props {
  minimal?: boolean;
}

function formatDuration(ms: number): string {
  const totalSec = Math.floor(ms / 1000);
  const min = Math.floor(totalSec / 60);
  const sec = totalSec % 60;
  return `${min}:${sec.toString().padStart(2, '0')}`;
}

export function StatusBar({ minimal = false }: Props) {
  const { status, getElapsedTime, agenda } = useSessionStore();
  const [elapsed, setElapsed] = useState(0);

  useEffect(() => {
    if (status !== 'listening') return;
    const interval = setInterval(() => setElapsed(getElapsedTime()), 1000);
    setElapsed(getElapsedTime());
    return () => clearInterval(interval);
  }, [status, getElapsedTime]);

  const covered = agenda?.items.filter(i => i.covered).length || 0;
  const total = agenda?.items.length || 0;

  if (minimal) {
    return (
      <div className="flex items-center gap-2 text-sm">
        <span className="w-2 h-2 bg-red-500 rounded-full animate-pulse-soft" />
        <span className="text-gray-600">{formatDuration(elapsed)}</span>
        <span className="text-gray-400">|</span>
        <span className="text-gray-600">{covered}/{total}</span>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-between mb-4 py-2 px-3 bg-red-50 rounded-lg border border-red-100">
      <div className="flex items-center gap-2">
        <span className="w-2.5 h-2.5 bg-red-500 rounded-full animate-pulse-soft" />
        <span className="text-sm font-medium text-red-700">Recording</span>
      </div>
      <span className="text-sm font-mono text-red-600">{formatDuration(elapsed)}</span>
    </div>
  );
}
